module.exports = __webpack_public_path__ + "img/zigzag.dfccd913.png";